<!--
 * @message: 列表页
 * @Author: cjc
 * @since: 2019-12-16 20:33:25
 * @lastTime: 2019-12-17 16:52:57
 * @LastAuthor: cjc
 -->
<template>
  <ul class="list-comp">
    <li class="list-item" v-for="item in filterList" :key="item.id" @click="gotoDetail(item.id)">
      <div class="list-item-wrapper">
        <span :class="'icon ' + params.type + '_icon'"></span>
        <div class="item-box">
          <div class="row">
            <h2 class="title">{{ item.title }}</h2>
            <span class="date">{{ item.date }}</span>
          </div>
          <div class="divide"></div>
          <p class="abstract">{{ item.abstract}}</p>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  data () {
    return {}
  },
  methods: {
    gotoDetail (id) {
      this.$router.push({
        path: '/details',
        query: {
          id: id
        }
      })
    }
  },
  computed: {
    filterList () {
      let result = []
      this.lists.map(item => {
        let start = item.date.indexOf('-')
        let end = item.date.indexOf(' ')
        let newDate = item.date.slice(++start, end)
        item.date = newDate.replace('-', '/')
        let filterItem = {}
        for (const key in item) {
          if (item.hasOwnProperty(key)) {
            const element = item[key]
            let temp = document.createElement('div')
            temp.innerHTML = element
            let result = temp.innerText || temp.textContent
            temp = null
            filterItem[key] = result
          }
        }
        result.push(filterItem)
      })
      return result
    }
  },
  props: ['lists', 'params']
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/mixins.scss";
.list-comp {
  @include size(100%);
  .list-item {
    @include size(100%);
    @include flex-center;
    &:hover {
      background-color: rgba(255, 255, 255, 0.2);
    }
    .list-item-wrapper {
      @include flex-between-center;
      @include size(1374px);
      color: #fff;
      .icon {
        @include size(45px, 200px);
      }
      .item-box {
        @include size(1329px, 200px);
        @include flex(center, flex-start, column);
        letter-spacing: 10px;
        font-family: STZhongsong;
        .row {
          @include size(100%);
          @include flex(space-between, baseline, row);
          box-sizing: border-box;
          padding-left: 55px;
          padding-top: 40px;
          .title {
            font-size: 34px;
            line-height: 1;
          }
          .date {
            font-size: 24px;
            align-self: baseline;
          }
        }
        .divide {
          @include size(100%, 1px);
          @include setBg("../../assets/images/subpage/item-divide.png");
          margin-top: 14px;
        }
        .abstract {
          @include size(auto, 84px);
          box-sizing: border-box;
          padding-left: 10px;
          font-size: 18px;
          line-height: 84px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/subpage/list.vue